import { render, staticRenderFns } from "./Step4.vue?vue&type=template&id=736a8f72&scoped=true&"
import script from "./Step4.vue?vue&type=script&lang=js&"
export * from "./Step4.vue?vue&type=script&lang=js&"
import style0 from "./Step4.vue?vue&type=style&index=0&id=736a8f72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736a8f72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('736a8f72')) {
      api.createRecord('736a8f72', component.options)
    } else {
      api.reload('736a8f72', component.options)
    }
    module.hot.accept("./Step4.vue?vue&type=template&id=736a8f72&scoped=true&", function () {
      api.rerender('736a8f72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/alteration/Step4.vue"
export default component.exports